import apiClient from "./apiClient";
import { StatisticsSummaryResponse } from "../models/ResponseModels/StatisticsSummaryResponse";

export interface GetStatisticsSummaryParams {
  from?: string;
  until?: string;
  property_id?: number;
  unit_id?: number;
  payment_status?: "unpaid" | "deposit" | "paid";
  status?: "reserved" | "checked_in" | "checked_out" | "cancelled";
  group_by?: "unit" | "property" | "month";
}

export const getStatisticsSummaryRequest = async (
  params?: GetStatisticsSummaryParams,
): Promise<StatisticsSummaryResponse> => {
  const response = await apiClient.get<StatisticsSummaryResponse>(
    "/statistics/summary",
    { params },
  );

  return response.data;
};
